import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Dashboard from './components/Dashboard';
import Settings from './components/settings/Settings';
import PlayersSettings from './components/settings/PlayersSettings';
import PlayerAssignments from './components/players/PlayerAssignments';
import PlayerQuickImporter from './components/players/PlayerQuickImporter';
import UserManagementPage from './components/users/UserManagementPage';
import Schedule from './components/Schedule';
import ProjectRounds from './components/schedule/ProjectRounds';
import RoundGames from './components/schedule/RoundGames';
import ScriptGenerator from './components/generator/ScriptGenerator';
import GameTickerPage from './components/ticker/GameTickerPage';
import ProtectedRoute from './components/ProtectedRoute';

function LegacyTickerRedirect() {
  const { projectId, roundId, gameId } = useParams();
  return <Navigate to={`/ticker/${projectId}/${roundId}/${gameId}`} replace />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* Protected routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/settings" element={
              <ProtectedRoute>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/players" element={
              <ProtectedRoute>
                <Layout>
                  <PlayersSettings />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/player-assignments" element={
              <ProtectedRoute>
                <Layout>
                  <PlayerAssignments />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/player-import" element={
              <ProtectedRoute>
                <Layout>
                  <PlayerQuickImporter />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/users" element={
              <ProtectedRoute>
                <Layout>
                  <UserManagementPage />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/schedule" element={
              <ProtectedRoute>
                <Layout>
                  <Schedule />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/schedule/:projectId" element={
              <ProtectedRoute>
                <Layout>
                  <ProjectRounds />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/schedule/:projectId/rounds/:roundId" element={
              <ProtectedRoute>
                <Layout>
                  <RoundGames />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/generator" element={
              <ProtectedRoute>
                <Layout>
                  <ScriptGenerator />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/ticker/:projectId/:roundId/:gameId" element={
              <ProtectedRoute>
                <div className="ticker-standalone-root">
                  <GameTickerPage standalone />
                </div>
              </ProtectedRoute>
            } />

            <Route path="/schedule/:projectId/rounds/:roundId/games/:gameId/ticker" element={
              <ProtectedRoute>
                <LegacyTickerRedirect />
              </ProtectedRoute>
            } />
            
            {/* Redirect unknown routes to dashboard */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
